import { auth_baseUrl, erp_baseUrl } from "../configuration/Configurations";
import { IsProdMode, ISUAT } from "./IsProdMode";
import { PORTAL_URLS } from "./portalConfig";

/* 
    Redirects to the Authentication Portal
*/
export const AUTH_BASE_URL = auth_baseUrl.auth;
export const ERP_BASE_URL = erp_baseUrl.erp;
/*
    Key is basically the name of the portal (from the portalConfig.js)
    Path is the path of the portal (this will use if key is not found in portalConfig.js)
*/
export const getPortalSelectionAppUrl = (key, path) => {
    const portal = PORTAL_URLS[key];

    if (!portal) return path;

    const baseUrl = (IsProdMode || ISUAT) ? portal.prod : portal.dev;
    return path ? `${baseUrl}${path}` : baseUrl;
};